import * as Yup from 'yup'

/*
  Pagamento de Pix por QR Code ou por copia e cola — as duas coisas são o mesmo payload EMV
  (BR Code), e é por isso que um formulário só atende as duas.

  A validação aqui é rasa de propósito. Quem diz o que o código significa — quem recebe,
  quanto custa hoje, se o valor pode ser outro — é a leitura na API, e este formulário tem
  duas etapas justamente para que essa resposta chegue antes de qualquer confirmação.
  Repetir aqui o CRC do EMV criaria uma segunda fonte de verdade para divergir dela.
*/
const bankingPixQrCodeValidator = Yup.object ().shape ({
  availableBalance: Yup.number ().default (0),

  payload: Yup.string ()
    .required ('Cole o código Pix ou leia o QR Code')
    .test (
      'pix-payload-format',
      'Este código não parece um Pix copia e cola',
      value => (value ?? '').trim ().startsWith ('000201')
    ),

  /*
    O valor só é preenchido quando o próprio QR Code admite outro valor. Num QR de valor
    fixo o campo nem aparece, e quem manda é a leitura feita no servidor na hora de pagar.
  */
  value: Yup.number ()
    .nullable ()
    .typeError ('Insira um valor válido')
    .min (0, 'Insira um valor válido')
    .max (Yup.ref ('availableBalance'), 'O valor é maior que o seu saldo disponível'),

  description: Yup.string ()
    .max (120, 'A descrição deve ter no máximo 120 caracteres')
})

export default bankingPixQrCodeValidator
